import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { NfcCard, Query } from 'graphql/generated/graphqlTypes';
import {
  generateMockNfcCard,
  generateMockNfcCardAssignment,
  generateMockNfcCardAssignmentBlockedInfo
} from 'mocks/graphqlMocks/nfcCard';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

dayjs.extend(utc);

export function mockedGetCardsData(getNfcCards: NfcCard[]): Pick<Query, 'getNfcCards'> {
  return {
    getNfcCards
  };
}

export const mockedGetCardsDataForQuery = mockedGetCardsData([
  generateMockNfcCard({
    name: '#0000000001',
    uuid: '#0000000001',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(1, 'year').add(4, 'minute').toISOString(),
      visitorName: 'Ruben Yanis'
    })
  }),
  generateMockNfcCard({
    name: '#0000000002',
    uuid: '#0000000002',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(1, 'year').add(3, 'minute').toISOString(),
      visitor: generateMockVisitor({
        id: '0000000002',
        name: 'Eva Yanis',
        expirationDate: dayjs().utc().add(2, 'day').toISOString()
      }),
      visitorName: 'Eva Yanis'
    })
  }),
  generateMockNfcCard({
    name: '#0000000003',
    uuid: '#0000000003',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(1, 'year').add(2, 'minute').toISOString(),
      blocked: generateMockNfcCardAssignmentBlockedInfo({
        reason: 'reason',
        since: dayjs().utc().subtract(1, 'day').toISOString()
      }),
      visitor: generateMockVisitor({
        id: '0000000003',
        name: 'Patryk Jakubiak',
        expirationDate: dayjs().utc().add(1, 'year').toISOString()
      }),
      visitorName: 'Patryk Jakubiak'
    })
  }),
  generateMockNfcCard({
    name: '#0000000004',
    uuid: '#0000000004',
    assignment: null
  }),
  generateMockNfcCard({
    name: '#0000000005',
    uuid: '#0000000005',
    updateRequired: true,
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(1, 'year').add(1, 'minute').toISOString(),
      visitor: generateMockVisitor({
        id: '0000000005',
        name: 'Roger Millard'
      }),
      visitorName: 'Roger Millard'
    })
  }),
  generateMockNfcCard({
    name: '#0000000006',
    uuid: '#0000000006',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().subtract(1, 'year').toISOString(),
      expired: true,
      visitor: generateMockVisitor({
        id: '0000000006',
        name: 'Adrian Hughes',
        expirationDate: dayjs().utc().add(1, 'month').toISOString()
      }),
      visitorName: 'Adrian Hughes'
    })
  }),
  generateMockNfcCard({
    name: '#0000000007',
    uuid: '#0000000007',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(1, 'year').toISOString(),
      visitor: generateMockVisitor({
        id: '0000000007',
        name: 'Joan Mcclain'
      }),
      visitorName: 'Joan Mcclain'
    })
  }),
  generateMockNfcCard({
    name: '#0000000008',
    uuid: '#0000000008',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(1, 'day').toISOString(),
      visitor: generateMockVisitor({
        id: '0000000008',
        name: 'Joan Mcclain'
      }),
      visitorName: 'Joan Mcclain'
    })
  }),
  generateMockNfcCard({
    name: '#0000000009',
    uuid: '#0000000009',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(3, 'day').toISOString(),
      visitor: generateMockVisitor({
        id: '0000000009',
        name: 'Joan Mcclain'
      }),
      visitorName: 'Joan Mcclain'
    })
  }),
  generateMockNfcCard({
    name: '#0000000010',
    uuid: '#0000000010',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(1, 'week').toISOString(),
      visitor: generateMockVisitor({
        id: '0000000010',
        name: 'Joan Mcclain'
      }),
      visitorName: 'Joan Mcclain'
    })
  }),
  generateMockNfcCard({
    name: '#0000000011',
    uuid: '#0000000011',
    assignment: generateMockNfcCardAssignment({
      expiryDate: dayjs().utc().add(1, 'month').toISOString(),
      visitor: generateMockVisitor({
        id: '0000000011',
        name: 'Joan Mcclain'
      }),
      visitorName: 'Joan Mcclain'
    })
  })
]);
